import { render, staticRenderFns } from "./EmailTemplateBuilder.vue?vue&type=template&id=f3f4f65a&scoped=true"
import script from "./EmailTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./EmailTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplateBuilder.vue?vue&type=style&index=0&id=f3f4f65a&prod&scoped=true&lang=css"
import style1 from "./EmailTemplateBuilder.vue?vue&type=style&index=1&id=f3f4f65a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f4f65a",
  null
  
)

export default component.exports